module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAM5LUtmcYAAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAtklEQVQ4T7WTSw6DMAxEQ3e9a4/I3YAQj3HiMQZFHektEuYDC8o7LdvFX7Rs399HmRxib9vOfsR7+rtQh2ktDRO0A35ozKQyARMMR4hXiqzqJZCzCyVf4vzSo8DUXQpyzwaA9TmuUTmMGDMrB9YX90QPKxJm5QAemq+cz+8MB6x4hOUUHZkYYn4F3U33Q6wcMP9JPwDFQ6wcMH8wAL0bYr5kAIKpH0tHbO65bCj545UpjWWWTKXsWVOnhFj8VcQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/herblore-icon.png
// module id = 493
// module chunks = 0